<template>
  <div class="w-full px-2 text-lg flex-center leading-5">
    <template v-if="activeDiscount && activeDiscount.expiresAt">
      <vue-countdown
        :time="activeDiscount.expiresAt"
        v-slot="{ days, hours, minutes, seconds }"
        :transform="transformSlotProps"
        class="flex-center gap-5 xs:gap-8 sm:gap-24 w-full"
        @end="handleCountdownEnd"
      >
        <div class="xs:w-1/2 text-right">
          <b>{{ activeDiscount.percentage }}% Off Ends Soon!</b>
        </div>
        <div class="xs:w-1/2 flex items-top gap-0.5">
          <div v-if="days">
            <div>{{ days }}</div>
            <div class="text-xs">days</div>
          </div>
          <div>:</div>
          <div v-if="hours">
            <div>{{ hours }}</div>
            <div class="text-xs">hours</div>
          </div>
          <div>:</div>
          <div>
            <div>{{ minutes }}</div>
            <div class="text-xs">mins</div>
          </div>
          <div>:</div>
          <div>
            <div>{{ seconds }}</div>
            <div class="text-xs">secs</div>
          </div>
        </div>
      </vue-countdown>
    </template>
    <template v-else-if="activeDiscount">
      You're saving {{ activeDiscount.percentage }}% on your subscription order!
    </template>
    <div
      v-else-if="$referral.hasReferral"
      v-html="referralContent"
      class="flex flex-col items-center justify-center gap-1 md:flex-row"
    />
    <template v-else>
      <div class="flex items-center gap-2">
        <div class="h-[66px] w-[92px] shrink-0 overflow-hidden">
          <img
            src="https://cdn.shopify.com/s/files/1/1209/5722/files/static.welcome-offer-banner.png"
            width="92"
            height="66"
            alt=""
            loading="lazy"
            aria-hidden="true"
            class="w-[92px] translate-y-2"
          >
        </div>
        <div
          v-html="defaultContent"
          class="text-center font-semibold text-base sm:text-lg"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useSpecialDiscountStore } from '@/stores'
import VueCountdown from '@chenfengyuan/vue-countdown'

defineProps<{
  referralContent: string
  defaultContent: string
}>()

const discountStore = useSpecialDiscountStore()
const { activeDiscount } = storeToRefs(discountStore)

const transformSlotProps = (props: Record<string, number>) => {
  const formattedProps = {}
  Object.entries(props).forEach(([ key, value ]) => {
    formattedProps[key] = value < 10 ? `0${value}` : String(value)
  })
  return formattedProps
}

const handleCountdownEnd = () => {
  discountStore.discountCode = undefined
  discountStore.activeDiscount = undefined
}
</script>
